import { render, staticRenderFns } from "./createSalesCataloge.vue?vue&type=template&id=e4ff2bf8&scoped=true"
import script from "./createSalesCataloge.vue?vue&type=script&lang=js"
export * from "./createSalesCataloge.vue?vue&type=script&lang=js"
import style0 from "./createSalesCataloge.vue?vue&type=style&index=0&id=e4ff2bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ff2bf8",
  null
  
)

export default component.exports